module.exports = __webpack_public_path__ + "static/img/t-btn.764190e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/t-btn.png
// module id = vEpc
// module chunks = 1